import { RootState } from "@/modules/common";

export const selectHistory = (state: RootState) =>
  state.history.orders[state.history.orders.length - 1];
